import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["font-family:inherit;font-size:inherit;max-width:800px;margin:0 auto;"]);
/**
 * Renders a `div` element that centers content on a page and makes sure the
 * content cannot exceed a certain width (default is 800px).
 *
 * @public
 * @author Connor Taylor
 */

var PageWrap = makeThemedComponent({
  themeKey: "PageWrap",
  component: "div",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default PageWrap;